import { render } from "./RequestAccess.vue?vue&type=template&id=3aeec8f3&scoped=true"
import script from "./RequestAccess.vue?vue&type=script&lang=js"
export * from "./RequestAccess.vue?vue&type=script&lang=js"

import "./RequestAccess.vue?vue&type=style&index=0&id=3aeec8f3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aeec8f3"]])

export default __exports__